// <s-cart-upsell>: the pop-up shown after a product-page Add to cart.
// s-product-form dispatches a cancelable "s-product-form:added" event once the cart (and its partials)
// has refreshed. If the freshly refreshed cart drawer holds an offer (<template data-upsell-source>,
// rendered by snippets/cart-addon.liquid inside the cart-drawer partial), this pop-up cancels the event,
// shows the offer and opens; otherwise the product form opens the cart drawer as usual.
// Attributes:
//   data-added-template — translated "__title__ is in your cart." line
//   data-added-fallback — line used when the product title is unknown
class SCartUpsell extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    document.addEventListener('s-product-form:added', (event) => this.#onAdded(event), opts);

    this.querySelector('[data-upsell-view-cart]')?.addEventListener('click', async () => {
      this.querySelector('dialog')?.close();
      const actions = window.Shopify?.actions;
      if (actions?.openCart) {
        await actions.openCart();
        return;
      }
      const drawer = document.getElementById('cart-drawer');
      if (drawer instanceof HTMLDialogElement && !drawer.open) drawer.showModal();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #onAdded(event) {
    const dialog = this.querySelector('dialog');
    const slot = this.querySelector('[data-upsell-offer-slot]');
    const source = document.querySelector('template[data-upsell-source]');
    if (!(dialog instanceof HTMLDialogElement) || !slot || !(source instanceof HTMLTemplateElement)) return;

    if (!event.detail?.upsell) return;

    const offer = source.content.querySelector('[data-upsell-offer]');
    if (!offer) return;

    event.preventDefault();
    slot.replaceChildren(offer.cloneNode(true));

    const added = this.querySelector('[data-upsell-added]');
    if (added) {
      const title = String(event.detail?.title || '').trim();
      added.textContent = title
        ? String(this.dataset.addedTemplate || '').replace('__title__', title)
        : String(this.dataset.addedFallback || '');
    }

    if (!dialog.open) dialog.showModal();
  }
}

if (!customElements.get('s-cart-upsell')) customElements.define('s-cart-upsell', SCartUpsell);
